import styled from 'styled-components';

const HeadingContainer = styled.div`
  display: flex;
  flex-grow: 1;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export default HeadingContainer;
